
import { defineComponent, onBeforeMount, ref } from 'vue';
import Moment from 'moment';
import { getLearnerStatus } from '@/utils/done_service';
//import { saveFeedback } from '@/utils/done_service';
import axios, { AxiosError } from 'axios';
import ErrorMessage from '@/components/global/ErrorMessage.vue';
import Greetings from '@/components/global/Greetings.vue';
// eslint-disable-next-line
import router from '../router';
// import moment from 'moment';

// import store from '@/store';

export default defineComponent({
  name: 'LearnerSubmitTask',
  components: { ErrorMessage, Greetings },
  // props: ['query'],
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const pass = ref(false);
    const fail = ref(false);
    const needReviewer = ref(false);
    const peerReviewTimestamps = ref();
    const mandatoryReviewsCount = ref();
    const vocUrl = ref('');
    const getLearner = ref();
    const allReviewerComments = ref();
    const skill = ref(localStorage.getItem('skillName'));
    const proficiency = ref(localStorage.getItem('proficiency'));
    const programId = ref(localStorage.getItem('programId'));
    const skillId = ref(localStorage.getItem('skillId'));
    const proficiencyId = ref(localStorage.getItem('profId'));
    const nextProficiency = ref();
    const lastModifiedDate = ref();
    const learnerTaskId = ref(props.query.learner_task_id);
    const helpmateLink = ref(localStorage.getItem('helpmateLink'));
    const renderReady = ref();
    const comment = ref();
    const feedback = ref();
    const validationShow = ref(false);
    const ratingValidationMsg = ref();
    const commentValidationMsg = ref();
    // const feedbackshow = ref(true);
    const isProgramInfinity = ref(true);
    const isProgramRestartable = ref();
    const learnerEligibleForRereview = ref(false);
    const errorResponse = ref();
    const showErrorMessage = ref(false);
    const programName = ref();
    const reviewerAssignmentStrategy = ref();
    const getLearnerDetails = async () => {
      try {
        renderReady.value = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any = await getLearnerStatus('learnerStatus', learnerTaskId.value);
        getLearner.value = res.data;
        reviewerAssignmentStrategy.value = getLearner.value.program_reviewer_strategy;
        console.log(`getLearner.value  ${JSON.stringify(getLearner.value)}`);
        renderReady.value = true;
        console.log('status', JSON.stringify(getLearner.value));
        if (getLearner.value.statusRes === 'notpassed') {
          renderReady.value = true;
          errorResponse.value = getLearner.value.statusMessage;
          showErrorMessage.value = true;
          needReviewer.value = false;
        } else if (getLearner.value.statusRes.learner_status === 'Passed') {
          vocUrl.value = getLearner.value.vocUrl;
          pass.value = true;
          needReviewer.value = false;
          allReviewerComments.value = getLearner.value.statusRes.all_reviewer_comments;
        } else if (getLearner.value.statusRes.learner_status === 'Fail') {
          fail.value = true;
          needReviewer.value = false;
          allReviewerComments.value = getLearner.value.statusRes.all_reviewer_comments;
          console.log(`getLearner.value.statusRes.linked_program_name ${getLearner.value.statusRes.linked_program_name}`);
          console.log(`getLearner.value.statusRes.linked_program_name !== 'infinity' ${getLearner.value.statusRes.linked_program_name !== 'infinity'}`);
          if (getLearner.value.statusRes.linked_program_name !== 'infinity') isProgramInfinity.value = false;
          isProgramRestartable.value = getLearner.value.program_is_restartable;
          if (getLearner.value.learner_eligible_for_rereview) learnerEligibleForRereview.value = true;
        } else if (getLearner.value.statusRes.learner_status === 'Need Reviewer') {
          if (getLearner.value.is_learner_not_allowed) {
            console.log('learner on hold submit task');
            router.push({ path: '/solidify', query: { skill_id: skillId.value, proficiency_id: proficiencyId.value, program_id: programId.value } });
          }
          needReviewer.value = true;
          // let localTime = Moment.utc(getLearner.value.statusRes.modified_date).toDate();
          // let date = new Date();
          lastModifiedDate.value = Moment(getLearner.value.statusRes.modified_date).format('dddd, MMMM Do YYYY, h:mm:ss a');
          mandatoryReviewsCount.value = getLearner.value.mandatoryReviewsCount || 3;
          //assigning values for peer review timestamps

          const peerReviewTimestampsTemp: string[] = [];
          for (let i = 0; i < mandatoryReviewsCount.value; i++) {
            let reviewerTimestamp = 'Waiting for Reviewer';
            if (getLearner.value.reviewers_status && getLearner.value.reviewers_status[i]) reviewerTimestamp = 'Reviewed on ' + Moment(getLearner.value.reviewers_status[i].review_end_date).format('dddd, MMMM Do YYYY');
            peerReviewTimestampsTemp.push(reviewerTimestamp);
          }
          peerReviewTimestamps.value = peerReviewTimestampsTemp;
          console.log(`lastModifiedDate.value ${lastModifiedDate.value}`);
          // lastModifiedDate.value = date;
        }
        // if (getLearner.value.feedback) {
        //   feedbackshow.value = false;
        // } else {
        //   feedbackshow.value = true;
        // }
      } catch (error) {
        renderReady.value = true;
        console.log('error while fetching learner details', error);
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          // console.log(err.response?.data);
          errorResponse.value = (err.response?.data as { message: string })?.message;
          // console.log(`errorMessage.value ${errorMessage.value}`);
        } else {
          errorResponse.value = 'There is an issue while fetching learner status, please contact helpmate.';
        }
        showErrorMessage.value = true;
      }
    };
    // const creatFeedback = async () => {
    //   try {
    //     renderReady.value = false;
    //     if (!feedback.value) {
    //       renderReady.value = true;
    //       validationShow.value = true;
    //       ratingValidationMsg.value = 'Please select Rating';
    //       setTimeout(() => {
    //         ratingValidationMsg.value = null;
    //         validationShow.value = false;
    //       }, 6000);
    //     } else if (!comment.value) {
    //       renderReady.value = true;
    //       validationShow.value = true;
    //       commentValidationMsg.value = 'Please add comment';
    //       setTimeout(() => {
    //         commentValidationMsg.value = null;
    //         validationShow.value = false;
    //       }, 6000);
    //     } else {
    //       const feedbackData = {
    //         learner_task_id: learnerTaskId.value,
    //         skill_id: localStorage.getItem('skillId'),
    //         proficiency_id: localStorage.getItem('profId'),
    //         skill_name: skill.value,
    //         proficiency_name: proficiency.value,
    //         program_id: localStorage.getItem('programId'),
    //         learner_key: localStorage.getItem('user_key'),
    //         rating: feedback.value,
    //         comment: comment.value,
    //       };
    //       // eslint-disable-next-line @typescript-eslint/no-explicit-any
    //       const res: any = await saveFeedback('/createFeedback', feedbackData);
    //       const feedbackRes = res.data;
    //       console.log(`res after creating feedback ${JSON.stringify(feedbackRes)}`);
    //       await getLearnerDetails();
    //       renderReady.value = true;
    //     }
    //   } catch (error) {
    //     console.log(error);
    //     renderReady.value = true;
    //     if (axios.isAxiosError(error)) {
    //       const err = error as AxiosError;
    //       // console.log(err.response?.data);
    //       errorResponse.value = (err.response?.data as { message: string })?.message;
    //       // console.log(`errorMessage.value ${errorMessage.value}`);
    //     } else {
    //       errorResponse.value = 'There is some issue while creating feedback, please contact helpmate.';
    //     }
    //     showErrorMessage.value = true;
    //   }
    // };
    onBeforeMount(async () => {
      // renderReady.value = false;
      programName.value = localStorage.getItem('programName');
      getLearnerDetails();
      if (proficiency.value === 'Beginner') {
        nextProficiency.value = 'Intermediate';
      } else if (proficiency.value === 'Intermediate') {
        nextProficiency.value = 'Proficient';
      } else if (proficiency.value === 'Proficient') {
        nextProficiency.value = 'Expert';
      }
      // renderReady.value = true;
    });
    const applyReview = async () => {
      router.push({ path: '/solidify/rereview', query: { learner_task_id: learnerTaskId.value } });
    };
    // const welcomeMsg = computed(() => store.getters['landing/welcomeMessage']);
    return {
      pass,
      fail,
      skill,
      proficiency,
      allReviewerComments,
      getLearner,
      needReviewer,
      peerReviewTimestamps,
      vocUrl,
      getLearnerDetails,
      lastModifiedDate,
      helpmateLink,
      renderReady,
      nextProficiency,
      // creatFeedback,
      comment,
      feedback,
      commentValidationMsg,
      ratingValidationMsg,
      validationShow,
      // feedbackshow,
      learnerEligibleForRereview,
      applyReview,
      isProgramInfinity,
      errorResponse,
      showErrorMessage,
      programName,
      reviewerAssignmentStrategy,
      isProgramRestartable,
    };
  },
});
